// import SectionHeader from './SectionHeader.jsx';

// const columns = [
//   {
//     label: 'Land',
//     title: 'Identify & Unlock',
//     items: [
//       'Identify high-potential parcels through micro-market analysis',
//       'Conduct feasibility, zoning & FSI studies',
//       'Match land to the right developer profile',
//     ],
//   },
//   {
//     label: 'Demand',
//     title: 'Understand & Shape',
//     items: [
//       'Analyse buyer profiles, price points & typology demand',
//       'Three key demand drivers understood early',
//       'Data-led briefs for design teams',
//     ],
//   },
//   {
//     label: 'Design',
//     title: 'Create & Optimise',
//     items: [
//       'Develop the right product to match demand',
//       'Maximise sellable area & layout efficiency',
//       'Design-led decisions at every milestone',
//     ],
//   },
//   {
//     label: 'Capital',
//     title: 'Structure & Deploy',
//     items: [
//       'Structured investment with clear returns',
//       'Investor alignment from Day 1',
//       'Risk-adjusted deployment model',
//     ],
//   },
// ];

// function ProcessSection() {
//   return (
//     <section id="how" data-section className="section-wrap fade-up">
//       <SectionHeader
//         label="The Process"
//         title="How It Comes Together"
//         subtitle="Four interconnected pillars, one aligned outcome."
//       />

//       <div className="how-grid">
//         {columns.map((column) => (
//           <div key={column.label} className="how-col">
//             <div className="how-col-label">{column.label}</div>
//             <div className="how-col-title">{column.title}</div>
//             <ul className="how-col-items">
//               {column.items.map((item) => (
//                 <li key={item}>{item}</li>
//               ))}
//             </ul>
//           </div>
//         ))}
//       </div>

//       <p className="how-tagline">Every step is a deliberate financial decision.</p>
//     </section>
//   );
// }

// export default ProcessSection;


import SectionHeader from './SectionHeader.jsx';

const processData = [
  {
    number: '01',
    label: 'Land',
    title: 'Identify & Unlock',
    text: 'High-potential parcels identified through deep market intelligence and feasibility analysis.',
  },
  {
    number: '02',
    label: 'Demand',
    title: 'Understand & Shape',
    text: 'Buyer psychology, pricing behaviour, and product demand mapped before execution begins.',
  },
  {
    number: '03',
    label: 'Design',
    title: 'Create & Optimise',
    text: 'Layouts, efficiency, and sellability engineered into every development decision.',
  },
  {
    number: '04',
    label: 'Capital',
    title: 'Structure & Deploy',
    text: 'Institutional-grade capital deployment aligned with long-term growth and reduced risk.',
  },
];

function ProcessSection() {
  return (
    <section
      id="how"
      data-section
      className="process-section fade-up"
    >
      {/* BACKGROUND */}
      <div className="process-noise" />
      <div className="process-grid-bg" />
      <div className="process-glow glow-one" />
      <div className="process-glow glow-two" />

      <SectionHeader
        label="The Process"
        title="How It Comes Together"
        subtitle="A connected ecosystem where every decision compounds value."
      />

      <div className="process-layout">

        {/* CENTER LINE */}
        <div className="center-line">
          <div className="beam-glow" />
        </div>

        {processData.map((item, index) => (
          <div
            key={item.number}
            className={`process-block process-${index + 1}`}
          >

            {/* HUGE NUMBER */}
            <div className="bg-number">
              {item.number}
            </div>

            {/* TOP */}
            <div className="block-top">
              <div className="mini-line" />
              <span>{item.label}</span>
            </div>

            {/* CONTENT */}
            <h3>{item.title}</h3>

            <p>{item.text}</p>

            {/* CONNECTOR */}
            <div className="connector">
              <div className="connector-dot" />
            </div>

          </div>
        ))}
      </div>

      {/* <div className="process-bottom-line">
        Every step is a deliberate financial decision.
      </div> */}

      <style>{`

        .process-section{
          position:relative;
          overflow:hidden;
          padding:80px 80px;
        }

        /* =========================
           BACKGROUND
        ========================= */

        .process-noise{
          position:absolute;
          inset:0;
          opacity:.04;
          background-image:
            radial-gradient(circle at 20% 20%, rgba(255,255,255,.4) 1px, transparent 1px);
          background-size:20px 20px;
          pointer-events:none;
        }

        .process-grid-bg{
          position:absolute;
          inset:0;
          background-image:
            linear-gradient(rgba(0,212,200,.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,212,200,.03) 1px, transparent 1px);

          background-size:90px 90px;

          mask-image:linear-gradient(
            to bottom,
            transparent,
            black 15%,
            black 85%,
            transparent
          );

          pointer-events:none;
        }

        .process-glow{
          position:absolute;
          border-radius:50%;
          filter:blur(120px);
          pointer-events:none;
        }

        .glow-one{
          width:420px;
          height:420px;
          background:rgba(0,212,200,.08);
          top:-180px;
          left:-140px;
        }

        .glow-two{
          width:380px;
          height:380px;
          background:rgba(0,120,255,.08);
          right:-120px;
          bottom:-140px;
        }

        /* =========================
           SECTION TITLE
        ========================= */

        .process-section .section-title{
          max-width:900px;
        }

        .process-section .section-sub{
          max-width:720px;
          font-size:18px;
          line-height:1.9;
        }

        /* =========================
           LAYOUT
        ========================= */

        .process-layout{
          position:relative;
          margin-top:100px;
          min-height:750px;
        }

        /* =========================
           CENTER BEAM
        ========================= */

        .center-line{
          position:absolute;
          left:50%;
          top:0;
          transform:translateX(-50%);
          width:1px;
          height:100%;
          background:
            linear-gradient(
              to bottom,
              transparent,
              rgba(0,212,200,.18),
              rgba(0,212,200,.45),
              transparent
            );
        }

        .beam-glow{
          position:absolute;
          left:50%;
          top:50%;
          transform:translate(-50%,-50%);
          width:8px;
          height:220px;
          border-radius:999px;
          background:rgba(0,212,200,.5);
          filter:blur(18px);
        }

        /* =========================
           BLOCKS
        ========================= */

        .process-block{
          position:absolute;
          width:420px;
          transition:.45s ease;
        }

        .process-block:hover{
          transform:translateY(-16px) scale(1.02);
        }

        .process-1{
          left:80px;
          top:0;
        }

        .process-2{
          right:80px;
          top:180px;
        }

        .process-3{
          left:80px;
          top:350px;
        }

        .process-4{
          right:80px;
          top:520px;
        }

        /* =========================
           BIG NUMBER
        ========================= */

        .bg-number{
          position:absolute;
          top:-90px;
          left:-10px;
          font-size:150px;
          line-height:1;
          font-weight:800;
          color:rgba(255,255,255,.03);
          letter-spacing:-10px;
          pointer-events:none;
          user-select:none;
        }

        /* =========================
           TOP
        ========================= */

        .block-top{
          display:flex;
          align-items:center;
          gap:14px;
          margin-bottom:26px;
        }

        .mini-line{
          width:52px;
          height:1px;
          background:rgba(0,212,200,.45);
          position:relative;
        }

        .mini-line::after{
          content:'';
          position:absolute;
          right:-2px;
          top:50%;
          transform:translateY(-50%);
          width:7px;
          height:7px;
          border-radius:50%;
          background:var(--cyan);
          box-shadow:0 0 16px var(--cyan);
        }

        .block-top span{
          color:var(--cyan);
          font-size:11px;
          letter-spacing:3px;
          text-transform:uppercase;
        }

        /* =========================
           CONTENT
        ========================= */

        .process-block h3{
          font-size:35px;
          line-height:.92;
          letter-spacing:0px;
          color:#fff;
          margin-bottom:20px;
          font-weight:700;
          max-width:400px;
          transition:.4s ease;
        }

        .process-block:hover h3{
          color:var(--cyan);
        }

        .process-block p{
          color:var(--text-muted);
          font-size:17px;
          line-height:1.5;
          max-width:360px;
        }

        /* =========================
           CONNECTOR
        ========================= */

        .connector{
          position:absolute;
          top:100px;
          width:180px;
          height:1px;
          background:rgba(0,212,200,.16);
        }

        .process-1 .connector,
        .process-3 .connector{
          right:-180px;
        }

        .process-2 .connector,
        .process-4 .connector{
          left:-210px;
        }

        .connector-dot{
          position:absolute;
          top:50%;
          right:-6px;
          transform:translateY(-50%);
          width:12px;
          height:12px;
          border-radius:50%;
          background:var(--cyan);
          box-shadow:
            0 0 20px var(--cyan),
            0 0 40px rgba(0,212,200,.4);
        }

        .process-2 .connector-dot,
        .process-4 .connector-dot{
          left:-6px;
        }

        /* =========================
           TAGLINE
        ========================= */

        .process-bottom-line{
          margin-top:140px;
          text-align:center;
          color:rgba(255,255,255,.45);
          font-size:15px;
          letter-spacing:1px;
        }

        /* =========================
           MOBILE
        ========================= */

        @media(max-width:1100px){

          .process-section{
            padding:100px 24px;
          }

          .process-layout{
            min-height:auto;
            display:flex;
            flex-direction:column;
            gap:110px;
            margin-top:90px;
          }

          .center-line{
            left:20px;
          }

          .process-block{
            position:relative;
            width:100%;
            left:auto !important;
            right:auto !important;
            top:auto !important;
            padding-left:60px;
          }

          .connector{
            display:none;
          }

          .process-block h3{
            font-size:52px;
            max-width:100%;
          }

          .process-block p{
            max-width:100%;
          }

          .bg-number{
            font-size:120px;
            top:-40px;
          }
        }

        @media(max-width:640px){

          .process-section{
            padding:90px 20px;
          }

          .process-layout{
            gap:90px;
          }

          .process-block{
            padding-left:46px;
          }

          .process-block h3{
            font-size:40px;
            letter-spacing:-2px;
            margin-bottom:22px;
          }

          .process-block p{
            font-size:15px;
            line-height:1.9;
          }

          .bg-number{
            font-size:90px;
          }

          .process-bottom-line{
            margin-top:90px;
          }
        }

      `}</style>
    </section>
  );
}

export default ProcessSection;
